export default "/images/blue-tick.png?ffa99e23fe0311caaa22fc38c339f5c2";